// Product Modal functionality
class ProductModal {
  constructor() {
    console.log('Creating ProductModal instance');
    this.modal = document.getElementById('productModal');
    if (!this.modal) {
      console.warn('Product modal element not found');
      return;
    }
  
    // Get all required modal elements
    this.overlay = this.modal.querySelector('.modal-overlay');
    this.modalContent = this.modal.querySelector('.modal-content');
    this.closeButton = this.modal.querySelector('.modal-close');
    this.productTitle = this.modal.querySelector('.product-title');
    this.productPrice = this.modal.querySelector('.product-price');
    this.productDescription = this.modal.querySelector('.product-description');
    this.mainImage = this.modal.querySelector('.main-image');
    this.thumbnailGallery = this.modal.querySelector('.thumbnail-gallery');
    this.modalFooter = this.modal.querySelector('.modal-footer');
    
    // Clear the modal footer completely
    if (this.modalFooter) {
      this.modalFooter.innerHTML = '';
      
      // Create the Add to Cart button
      this.addToCartButton = document.createElement('button');
      this.addToCartButton.className = 'add-to-cart-button';
      this.addToCartButton.innerHTML = `
        <svg class="cart-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="button-text">Add to Cart</span>
      `;
      
      // Create the Notify Me button
      this.notifyMeButton = document.createElement('button');
      this.notifyMeButton.className = 'notify-me-button';
      this.notifyMeButton.innerHTML = `
        <svg class="bell-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="button-text">Notify Me</span>
      `;
      
      // Initially add only the Add to Cart button
      this.modalFooter.appendChild(this.addToCartButton);
    }
    
    this.sizeGrid = this.modal.querySelector('.size-grid');
    this.inStockIndicator = this.modal.querySelector('.in-stock-indicator');
    
    // Track the current product info
    this.currentProductData = null;
    
    // Check if all required elements exist
    if (!this.overlay || !this.closeButton || !this.productTitle || 
        !this.productPrice || !this.productDescription || !this.mainImage || 
        !this.thumbnailGallery || !this.addToCartButton || !this.sizeGrid) {
      console.warn('Some required modal elements are missing');
      return;
    }
  
    // Create the in-stock indicator if it doesn't exist
    if (!this.inStockIndicator) {
      console.log('Creating missing in-stock indicator');
      this.inStockIndicator = document.createElement('span');
      this.inStockIndicator.className = 'in-stock-indicator';
      
      // Find the price container and insert after it
      const priceContainer = this.modal.querySelector('.product-price-container');
      if (priceContainer) {
        priceContainer.after(this.inStockIndicator);
      } else {
        // Fallback: insert before description
        this.productDescription.before(this.inStockIndicator);
      }
    }
    
    this.bindEvents();
    console.log('ProductModal initialized successfully');
  }

  bindEvents() {
    // Close modal when clicking overlay or close button
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.close();
      }
    });
    
    this.closeButton.addEventListener('click', () => {
      console.log('Close button clicked');
      this.close();
    });

    // Close modal when pressing Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    });

    // Handle add to cart button click
    this.addToCartButton.addEventListener('click', () => {
      const selectedSize = this.modal.querySelector('.size-option.selected');
      if (!selectedSize) {
        alert('Please select a size');
        return;
      }
      const variantId = selectedSize.dataset.variantId;
      if (!variantId) {
        alert('Please select a size');
        return;
      }
      console.log('Adding to cart variant ID:', variantId);
      window.addToCart(variantId, 1, this.addToCartButton);
    });

    // Handle notify me button click
    this.notifyMeButton.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Check if a size is selected
      const selectedSize = this.sizeContainer ? this.sizeContainer.querySelector('.size-option.selected') : null;
      const sizeGrid = this.sizeContainer ? this.sizeContainer.querySelector('.size-grid') : null;
      
      // If we have a size selector but no size is selected
      if (this.sizeContainer && sizeGrid && !selectedSize) {
        // Highlight the size grid to indicate selection is needed
        sizeGrid.classList.add('highlight-selection');
        
        // Add a message if it doesn't exist
        let message = this.sizeContainer.querySelector('.size-selection-message');
        if (!message) {
          message = document.createElement('span');
          message.className = 'size-selection-message';
          message.textContent = 'Please select a size to be notified about';
          this.sizeContainer.appendChild(message);
        }
        
        // Scroll to the size container
        this.sizeContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Remove the highlight after animation completes
        setTimeout(() => {
          sizeGrid.classList.remove('highlight-selection');
        }, 2500);
        
        return;
      }
      
      // Get the variant ID
      const variantId = this.notifyMeButton.dataset.variantId || null;
      const productId = this.notifyMeButton.dataset.productId || null;
      const sizeValue = selectedSize ? selectedSize.dataset.value : null;
      
      console.log('Notify Me clicked for product:', productId, 'variant:', variantId, 'size:', sizeValue);
      
      // Open the newsletter popup instead of showing a notification
      this.openNotifyPopup(productId, variantId);
      
      // Close the modal after opening the newsletter popup
      this.close();
    });

    // Handle size selection
    this.sizeGrid.addEventListener('click', (e) => {
      const sizeOption = e.target.closest('.size-option');
      if (sizeOption) {
        this.sizeGrid.querySelectorAll('.size-option').forEach(option => {
          option.classList.remove('selected');
        });
        sizeOption.classList.add('selected');
        
        // Check if the selected variant is available
        const isAvailable = !sizeOption.classList.contains('sold-out');
        console.log('Size selected:', sizeOption.textContent, 'Available:', isAvailable);
        
        // Show appropriate button based on availability
        this.toggleButtons(isAvailable, sizeOption.dataset.variantId);
      }
    });
  }
  
  openNotifyPopup(productId, variantId) {
    // Open newsletter popup
    if (window.newsletterPopup) {
      window.newsletterPopup.open(productId, variantId);
      console.log('Opening newsletter popup for product:', productId, 'variant:', variantId);
    } else {
      console.warn('Newsletter popup not found');
      alert('Please enter your email to be notified when this product is back in stock.');
    }
  }
  
  areAllVariantsSoldOut() {
    if (!this.currentProductData || !this.currentProductData.variants) {
      return true; // Default to true if no data
    }
    
    // Check if all variants are sold out
    return this.currentProductData.variants.every(variant => !variant.available);
  }

  toggleButtons(isAvailable, variantId = null) {
    console.log('Toggling buttons, isAvailable:', isAvailable);
    
    // Clear the modal footer
    if (this.modalFooter) {
      this.modalFooter.innerHTML = '';
    }
    
    if (isAvailable) {
      // For available products, show the Add to Cart button
      this.modalFooter.appendChild(this.addToCartButton);
      
      // Update variant ID
      if (variantId) {
        this.addToCartButton.dataset.variantId = variantId;
      }
    } else {
      // For unavailable products, show the Notify Me button
      this.modalFooter.appendChild(this.notifyMeButton);
      
      // Update variant ID
      if (variantId) {
        this.notifyMeButton.dataset.variantId = variantId;
      }
    }
  }
  open(productCard) {
    console.log('Opening modal for product:', productCard.dataset.productTitle);
    
    // Get product data from the clicked card
    const title = productCard.dataset.productTitle;
    const price = productCard.dataset.productPrice;
    const description = productCard.dataset.productDescription;
    const mainImageUrl = productCard.dataset.productImage;
    const mainImageThumb = productCard.dataset.productImageThumb;
    const images = JSON.parse(productCard.dataset.images || '[]');
    const imageThumbs = JSON.parse(productCard.dataset.imagesThumbs || '[]');
    const variants = JSON.parse(productCard.dataset.variants || '[]');
    
    // Store product data for later reference
    this.currentProductData = {
      title,
      price,
      description,
      variants
    };
    
    // Track product view in modal
    if (window.CF508Analytics) {
      const productId = productCard.dataset.productId;
      const productType = productCard.dataset.productType || 'Unknown';
      const priceValue = parseFloat(price.replace(/[^0-9.-]+/g, '')) || 0;
      
      window.CF508Analytics.trackEvent('product_modal_view', {
        product_id: productId,
        product_name: title,
        product_type: productType,
        price: priceValue,
        currency: 'USD',
        view_context: 'modal'
      });
      
      // Also track as a general product view
      window.CF508Analytics.trackViewProduct({
        id: productId,
        title: title,
        type: productType,
        price: priceValue,
        vendor: productCard.dataset.productVendor || 'Unknown'
      });
    }
    
    // Determine if product is available based on the window-dot
    const isAvailable = productCard.querySelector('.window-dot.in-stock') !== null;
    console.log('Product availability:', isAvailable);
    
    const productId = productCard.dataset.productId;

    // Update modal content
    this.productTitle.textContent = title;
    this.productPrice.textContent = price;
    
    // Update availability right after price
    if (isAvailable) {
      this.inStockIndicator.textContent = 'In Stock';
      this.inStockIndicator.style.color = '#28c840';
      this.inStockIndicator.classList.remove('out-of-stock');
      this.inStockIndicator.classList.add('in-stock');
    } else {
      this.inStockIndicator.textContent = 'Out of Stock';
      this.inStockIndicator.style.color = '#ff5f57';
      this.inStockIndicator.classList.remove('in-stock');
      this.inStockIndicator.classList.add('out-of-stock');
    }
    
    // Toggle the appropriate buttons based on availability
    this.toggleButtons(isAvailable);
    
    // Set data attributes for the buttons
    this.addToCartButton.dataset.productId = productId;
    this.notifyMeButton.dataset.productId = productId;
    
    this.productDescription.innerHTML = description;

    // Show loading state for main image
    this.mainImage.classList.add('loading');
    this.mainImage.src = mainImageThumb; // Start with thumbnail
    this.mainImage.alt = title;

    // Update size options
    this.sizeGrid.innerHTML = '';
    this.sizeGrid.classList.remove('highlight-selection');
    
    variants.forEach(variant => {
      const sizeOption = document.createElement('div');
      sizeOption.className = 'size-option';
      sizeOption.textContent = variant.title;
      sizeOption.dataset.variantId = variant.id;
      
      if (!variant.available) {
        sizeOption.classList.add('sold-out');
      }
      
      this.sizeGrid.appendChild(sizeOption);
    });
    
    // Automatically select a size when there's only one option
    if (variants.length === 1) {
      const singleOption = this.sizeGrid.querySelector('.size-option');
      if (singleOption) {
        singleOption.classList.add('selected');
      }
    }
    
    // Add a message to encourage size selection for out of stock items
    if (!isAvailable && variants.length > 1) {
      const sizeMessage = document.createElement('div');
      sizeMessage.className = 'size-selection-message';
      sizeMessage.textContent = 'Select a size to be notified when back in stock';
      this.sizeGrid.parentNode.insertBefore(sizeMessage, this.sizeGrid.nextSibling);
    }

    // Show modal
    this.modal.style.display = 'flex';
    setTimeout(() => {
      this.modal.classList.add('active');
    }, 10);
    document.body.style.overflow = 'hidden';
    console.log('Modal opened successfully');
  }

  close() {
    console.log('Closing modal');
    
    // Hide modal
    this.modal.classList.remove('active');

    // Remove active class after transition
    setTimeout(() => {
      this.modal.style.display = 'none';
      
      // Clear any size selection message
      const sizeMessage = this.modal.querySelector('.size-selection-message');
      if (sizeMessage) {
        sizeMessage.remove();
      }
    }, 300);

    document.body.style.overflow = '';
  }
}

// Initialize modal when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing ProductModal');
  window.productModal = new ProductModal();
  
  // Bind click events to product cards and buttons
  document.querySelectorAll('.simple-card').forEach(card => {    // Handle add to cart button click
    const addToCartBtn = card.querySelector('.add-to-cart-button');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent event from bubbling to card
        
        console.log('Add to cart button clicked, opening modal');
        // Always open modal when clicking add to cart button
        window.productModal.open(card);
      });
    }
    
    // Handle notify me button click in product cards
    const notifyMeBtn = card.querySelector('.notify-me-button');
    if (notifyMeBtn) {
      notifyMeBtn.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent event from bubbling to card
        console.log('Notify me button clicked, opening modal');
        
        // Open modal when clicking on the notify me button in the product card
        if (window.productModal) {
          window.productModal.open(card);
        }
      });    }
    
    // Handle card click (product details) - Re-enabled modal opening on card click
    card.addEventListener('click', (e) => {
      // Don't open modal if clicking buttons
      if (!e.target.closest('.add-to-cart-button') && !e.target.closest('.notify-me-button')) {
        console.log('Product card clicked, opening modal');
        window.productModal.open(card);
      }
    });
  });
  
  console.log('ProductModal event listeners bound');
});

// Check if newsletter popup exists
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    if (typeof window.newsletterPopup === 'undefined' || !window.newsletterPopup) {
      console.warn('Newsletter popup functionality not found. "Notify Me" buttons may not work as expected.');
      
      // Create a basic newsletter popup functionality if it doesn't exist
      window.newsletterPopup = {
        open: function(variantId) {
          alert('This is a placeholder for the newsletter signup. In the actual implementation, this would collect emails for back-in-stock notifications.');
          console.log('Newsletter popup opened for variant ID: ' + variantId);
        }
      };
    }
  }, 1000); // Check after 1 second to ensure all scripts are loaded
});